// extracted by mini-css-extract-plugin
export default {"container":"style_container__Hn9CA","img":"style_img__7AQPD","text":"style_text__M2DWl","submitBtn":"style_submitBtn__86QPV"};